import axios from "axios";
import { Cache } from "aws-amplify";
import {
  redirectToLogin,
  refreshToken,
} from "../store/actions/auth/authActions";

class APIClient {
  make() {
    var env = process.env.REACT_APP_BACKEND_ENV;
    var base_path = "";

    switch (env) {
      case "prod":
        base_path = process.env.REACT_APP_WAA_BACKEND_BASE_PATH_PROD;
        break;
      case "test":
      case "uat":
        base_path = process.env.REACT_APP_WAA_BACKEND_BASE_PATH_TEST;
        break;
      case "dev":
        base_path = process.env.REACT_APP_WAA_BACKEND_BASE_PATH_DEV;
        break;
      default:
        base_path = process.env.REACT_APP_WAA_BACKEND_BASE_PATH_LOCAL;
        break;
    }

    axios.interceptors.request.use(
      (config) => {
        // const accessToken = Cache.getItem("accessToken");
        const token = Cache.getItem("token");

        config.baseURL = base_path;
        if (token) config.headers["Authorization"] = `Bearer ${token}`;

        return config;
      },
      (error) => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      (res) => {
        return res;
      },
      async (error) => {
        const { config, response } = error;
        const expiredToken =
          response?.data.status_message === "Token is Expired";

        const expiredRefresh =
          response?.data.message ===
          "Token has expired and can no longer be refreshed";

        if (response.status === 401 && expiredToken && !config?.sent) {
          const newToken = await refreshToken();

          if (newToken) {
            config.headers = {
              ...config.headers,
              Authorization: `Bearer ${newToken}`,
            };
            Promise.reject(error);
          }

          config.sent = true;
          config._retry = true;
          return axios.request(config);
        }

        if (response.status === 401 && expiredRefresh) {
          localStorage.clear();
          Cache.clear();
          redirectToLogin();
          // await logoutUser();
        }
        return Promise.reject(error);
      }
    );

    return axios;
  }
}

export default APIClient;
